import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { LogOut } from "lucide-react";

export function DashboardShell({ title, children, actions }) {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const doLogout = async () => {
    await logout();
    nav("/login");
  };
  return (
    <div className="min-h-screen bg-background text-foreground">
      <header className="sticky top-0 z-40 glass border-b border-border">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 sm:px-6">
          <div className="flex items-center gap-4">
            <Logo size="sm" subtitle={false} />
            <div className="hidden border-l border-border pl-4 sm:block">
              <div className="text-xs text-muted-foreground">{title}</div>
              <div className="text-sm font-semibold">{user?.name} <span className="text-gold">· {user?.role?.replace("_", " ")}</span></div>
            </div>
          </div>
          <div className="flex items-center gap-2">
            {actions}
            <Button variant="outline" size="sm" onClick={doLogout} className="gap-1.5 gold-border text-muted-foreground hover:text-gold" data-testid="logout-btn">
              <LogOut size={15} /> <span className="hidden sm:inline">Logout</span>
            </Button>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-7xl px-4 py-6 sm:px-6">{children}</main>
    </div>
  );
}

export function useServerNow(offsetRef) {
  const [, force] = useState(0);
  useEffect(() => {
    const iv = setInterval(() => force((n) => n + 1), 1000);
    return () => clearInterval(iv);
  }, []);
}
